import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: []
})
export class SharedPipesModule { }



// WEBPACK FOOTER //
// ./src/app/shared/pipes/shared-pipes.module.ts